import React, { useState } from 'react';
import { Input, Select, Button, Space, Row, Col } from 'antd';
import { SearchOutlined, ReloadOutlined } from '@ant-design/icons';

interface SearchBarProps {
  onSearch: (query: string, status: string) => void;
  onReset: () => void;
}

const statusOptions = [
  { label: 'Discovered', value: 'Discovered' },
  { label: 'Processed', value: 'Processed' },
  { label: 'Removed', value: 'Removed' },
  { label: 'Queued', value: 'Queued' },
  { label: 'Failed', value: 'Failed' },
];

const SearchBar: React.FC<SearchBarProps> = ({ onSearch, onReset }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedStatus, setSelectedStatus] = useState<string>('');

  const handleSearch = () => {
    onSearch(searchQuery, selectedStatus);
  };

  const handleReset = () => {
    setSearchQuery('');
    setSelectedStatus('');
    onReset();
  };

  return (
    <div style={{ marginBottom: 16 }}>
      <Row gutter={[12, 12]}>
        <Col xs={24} md={14}>
          <Input
            placeholder="Search for Documents using Title"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onPressEnter={handleSearch}
            size="large"
            style={{ borderRadius: 10 }}
          />
        </Col>
        <Col xs={24} md={6}>
          <Select
            placeholder="Select Document Status"
            value={selectedStatus || undefined}
            onChange={setSelectedStatus}
            options={statusOptions}
            allowClear
            size="large"
            style={{ width: '100%', borderRadius: 10 }}
          />
        </Col>
        <Col xs={24} md={4}>
          <Space.Compact style={{ width: '100%' }}>
            <Button
              type="primary"
              icon={<SearchOutlined />}
              onClick={handleSearch}
              size="large"
              style={{ flex: 1 }}
            >
              Search
            </Button>
            <Button
              type="dashed"
              icon={<ReloadOutlined />}
              onClick={handleReset}
              size="large"
              style={{ flex: 1 }}
            >
            </Button>
          </Space.Compact>
        </Col>
      </Row>
    </div>
  );
};

export default SearchBar;
